module.exports = __webpack_public_path__ + "media/img/home/directions/list-3-8ea82330b08afb54c92425da2dc10f96.svg";